import React, { Component } from 'react';
import { toast, ToastContainer, MDBCardText, MDBCard, MDBCardTitle, MDBRow, MDBCol, MDBBtn, MDBIcon, MDBInput, MDBInputGroup, MDBContainer, MDBBadge } from 'mdbreact';
import Header from './ComponentFragments/Header';
import DataLayer from '../Utilities/DataLayer';
import Formatter from '../Utilities/Formatter';
import Colors from '../Styles/Colors';



class PFCancel extends Component {
    constructor(props) {
        super(props);
        this.state = {
            sfOrderId: 0,
            sfInvoiceId: 0,
            receiptReference: "",
            errorMessage: "",
            errorOccurred: false,
            headerText: "",
            counter: 0,
        }
        this.formatter = new Formatter();
        this.dl = new DataLayer();
        this.getQueryParams = this.getQueryParams.bind(this);
        this.formatView = this.formatView.bind(this);
    }

    getQueryParams() {
        // initialize an empty object
        let result = {};
        // get URL query string
        let params = window.location.search;
        // remove the '?' character
        params = params.substr(1);
        let queryParamArray = params.split('&');
        // iterate over parameter array
        queryParamArray.forEach(function (queryParam) {
            // split the query parameter over '='
            let item = queryParam.split("=");
            result[item[0]] = decodeURIComponent(item[1]);
        });
        // return result object

        return result;
    }

    CheckCancellationFlag = async (params) => {
        let sfOrderPayflexOrder = {
            PayFlexOrderId: params.orderId,
            SfOrderId: 0
        }
        let response = await this.dl.Post("/Payflex/CancelPayflexOrder", sfOrderPayflexOrder, false);
        console.log(response);

        if (response.data) {
            clearInterval(this.intervalId);
            this.props.history.push({
                pathname: '/salesforce/cart'
            })
            this.props.loaderOff()
        }

        this.setState((prevState) => {
            const newCounter = prevState.counter + 1;
            
            // If counter reaches 5, stop the interval
            if (newCounter >= 5) {
                clearInterval(this.intervalId);
                // failed to get cancellation flag set cancelled on order and redirect back to cart
                this.props.history.push({
                    pathname: '/salesforce/cart'
                })
                this.props.loaderOff()
            }

            return { counter: newCounter };
        });
    }

    async componentDidMount() {
        var params = this.getQueryParams();
        this.intervalId = setInterval(() => this.CheckCancellationFlag(params), 5000); // 3 seconds
    }

    componentWillUnmount() {
        clearInterval(this.intervalId);
    }

    //async componentWillMount() {
    //    var params = this.getQueryParams();
    //    let sfOrderPayflexOrder = {
    //        PayFlexOrderId: params.orderId,
    //        SfOrderId: 0
    //    }
    //    let response = await this.dl.Post("/Payflex/CancelPayflexOrder", sfOrderPayflexOrder, false);
    //    console.log(params.orderId);
    //    //this.setState({
    //    //    sfOrderId: response.sfOrderId,
    //    //    sfInvoiceId: response.sfInvoiceId,
    //    //    receiptReference: response.receiptReference,
    //    //    errorOccurred: response.errorOccurred,
    //    //    headerText: response.data,
    //    //    errorMessage: response.errorMessage
    //    //})
    //    this.props.loaderOff()
    //    this.props.history.push({
    //        pathname: '/salesforce/cart'
    //    })
    //    //if (!response.errorOccurred) {
    //    //    this.props.updateCartCount(0);
    //    //}
    //}

    formatView() {
        return (
            <div>
                <Header headerText={this.state.headerText}
                    subHeaderText="You have cancelled your Payflex transaction"
                    hideSearch={true}
                />
                <br />

            </div>
        )

    }

    render() {
        return (
            <div>
                {this.formatView()}
            </div>
        )
    }
}

export default PFCancel;